var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"confirm-dialog","modal-class":_vm.theme,"hide-header":"","hide-footer":"","centered":"","body-class":"modal__terms","size":"lg"}},[_c('Terms',{attrs:{"inModal":true}}),_c('div',{staticClass:"modal__controls"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.hide}},[_vm._v("Close")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }